import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@sm/wds-react';

export const MenusWithoutSubMenu = ({ children }) => {
  return (
    <List interactive className="sm-mobile-menu-anon">
      {children}
    </List>
  );
};

export default MenusWithoutSubMenu;

MenusWithoutSubMenu.propTypes = {
  children: PropTypes.node.isRequired,
};
